import { render, staticRenderFns } from "./AddSlider.vue?vue&type=template&id=f9846dc4&scoped=true"
import script from "./AddSlider.vue?vue&type=script&lang=js"
export * from "./AddSlider.vue?vue&type=script&lang=js"
import style0 from "./AddSlider.vue?vue&type=style&index=0&id=f9846dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9846dc4",
  null
  
)

export default component.exports